import React from "react";
import QuotationResultsCardComponent from "./quotation-results-card.component";

const QuotationResultsCardContainer = () => {
  return <QuotationResultsCardComponent />;
};

export default QuotationResultsCardContainer;
